import { BaseModel } from '../../_base/crud';
import { Blocker } from '../../models';
import { FormTransactionLink } from '../../../views/pages/forms-templates/models';

export class Task extends BaseModel {
  id: number;
  title: string;
  description: string;
  progress = 'PLANNED';
  priority: 'HIGH' | 'MEDIUM' | 'LOW';
  due_date: any;
  is_recurring = false;
  parent_id: number;
  task_entities: any;
  task_responsible_users: any;
  task_followers: any;
  task_tags: any;
  attachments: any;
  company_id: number;
  completed: boolean;
  task_template: any;
  user_id: number;
  topic: string;
  category_id: number;
  start_time: string;
  end_time: string;
  status: string;
  url_resource: string;
  office_id: number;
  blockers: Blocker[];
  followup_id;
  created;
  check_lists: any[];
  transaction_form: FormTransactionLink;
  clear() {
    this.progress = 'PLANNED';
    this.completed = false;
  }
}
